const footerLinks = {
  services: [
    { label: '热门排行', href: '#ranking' },
    { label: '精选推荐', href: '#cards' },
    { label: '专题合集', href: '#index' },
    { label: '移动观影', href: '#app' },
  ],
  support: [
    { label: '常见问题', href: '#faq' },
    { label: '联系我们', href: '#contact' },
    { label: '关于我们', href: '#about' },
    { label: '意见反馈', href: '#contact' },
  ],
  content: [
    { label: '高清电影', href: '#cards' },
    { label: '高清电视剧', href: '#cards' },
    { label: '热门综艺', href: '#index' },
    { label: '动漫专区', href: '#index' },
  ],
};

export default function Footer() {
  const handleAnchor = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer id="footer" className="bg-secondary-900 text-background-100">
      {/* Main footer */}
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="col-span-2 md:col-span-1">
            <a
              href="#hero"
              onClick={(e) => { e.preventDefault(); handleAnchor('#hero'); }}
              className="flex items-center gap-2 no-underline mb-4"
            >
              <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-movie-2-fill text-background-50 text-lg"></i>
              </div>
              <span className="text-xl font-heading font-bold text-background-50 whitespace-nowrap">
                久久影视
              </span>
            </a>
            <p className="text-xs text-background-300 leading-relaxed mb-4 max-w-xs">
              久久影视是一个免费高清影视在线平台，聚合海量高清电影与高清电视剧资源。1080P画质、流畅不缓冲，零成本畅享视听盛宴。
            </p>
            <div className="flex items-center gap-3">
              <div className="w-8 h-8 rounded-lg bg-background-50/10 flex items-center justify-center cursor-pointer hover:bg-background-50/20 transition-colors">
                <i className="ri-wechat-line text-background-300 text-sm"></i>
              </div>
              <div className="w-8 h-8 rounded-lg bg-background-50/10 flex items-center justify-center cursor-pointer hover:bg-background-50/20 transition-colors">
                <i className="ri-weibo-line text-background-300 text-sm"></i>
              </div>
              <div className="w-8 h-8 rounded-lg bg-background-50/10 flex items-center justify-center cursor-pointer hover:bg-background-50/20 transition-colors">
                <i className="ri-bilibili-line text-background-300 text-sm"></i>
              </div>
            </div>
          </div>

          {/* Links */}
          <div>
            <h3 className="text-sm font-heading font-bold text-background-50 mb-4">快捷导航</h3>
            <ul className="space-y-2.5">
              {footerLinks.services.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    onClick={(e) => { e.preventDefault(); handleAnchor(link.href); }}
                    className="text-xs text-background-300 hover:text-background-50 transition-colors cursor-pointer"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-heading font-bold text-background-50 mb-4">帮助支持</h3>
            <ul className="space-y-2.5">
              {footerLinks.support.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    onClick={(e) => { e.preventDefault(); handleAnchor(link.href); }}
                    className="text-xs text-background-300 hover:text-background-50 transition-colors cursor-pointer"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-heading font-bold text-background-50 mb-4">内容分类</h3>
            <ul className="space-y-2.5">
              {footerLinks.content.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    onClick={(e) => { e.preventDefault(); handleAnchor(link.href); }}
                    className="text-xs text-background-300 hover:text-background-50 transition-colors cursor-pointer"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Partners */}
        <div className="mt-12 pt-8 border-t border-background-50/10">
          <h3 className="text-sm font-heading font-bold text-background-50 mb-4">合作伙伴</h3>
          <div className="flex flex-wrap items-center gap-6">
            <span className="text-xs text-background-400">虚位以待，诚邀优质影视内容方合作</span>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-background-50/10">
        <div className="max-w-7xl mx-auto px-4 md:px-6 py-4 flex flex-col sm:flex-row items-center justify-between gap-2">
          <p className="text-xs text-background-400">
            &copy; 2024 久久影视 - 高清影视在线免费看。本站所有内容均来自互联网，仅供学习交流。
          </p>
          <div className="flex items-center gap-4">
            <span className="text-xs text-background-400 cursor-pointer hover:text-background-300 transition-colors">隐私政策</span>
            <span className="text-xs text-background-400 cursor-pointer hover:text-background-300 transition-colors">服务条款</span>
          </div>
        </div>
      </div>
    </footer>
  );
}